'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LineItemQuantitySelect = require('../LineItemQuantitySelect');

var _LineItemQuantitySelect2 = _interopRequireDefault(_LineItemQuantitySelect);

var _ColorSwatch = require('../ColorSwatch');

var _ColorSwatch2 = _interopRequireDefault(_ColorSwatch);

var _Price = require('../Price');

var _Price2 = _interopRequireDefault(_Price);

var _paintersStyle = require('./paintersStyle.scss');

var _paintersStyle2 = _interopRequireDefault(_paintersStyle);

var _lineItem = require('../../helpers/lineItem');

var _localisedPaths = require('../../helpers/localisedPaths');

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaintersLineItem = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_paintersStyle2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaintersLineItem, _React$Component);

  function PaintersLineItem() {
    (0, _classCallCheck3.default)(this, PaintersLineItem);
    return (0, _possibleConstructorReturn3.default)(this, (PaintersLineItem.__proto__ || (0, _getPrototypeOf2.default)(PaintersLineItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaintersLineItem, [{
    key: 'variant',
    value: function variant() {
      return this.props.variant;
    }
  }, {
    key: 'userRoles',
    value: function userRoles() {
      if (!this.props.user) {
        return [];
      }

      return this.props.user.roles || [];
    }
  }, {
    key: 'renderColourChipSizeSwitcher',
    value: function renderColourChipSizeSwitcher(size) {
      var _this2 = this;

      var newSize = size === 'A8' ? 'A5' : 'A8';
      return _react2.default.createElement(
        'button',
        {
          styleName: 'lineItem__sizeSelect',
          onClick: function onClick(event) {
            return _this2.props.switchChipSize(event, newSize, _this2.props);
          }
        },
        'Switch to ',
        newSize
      );
    }
  }, {
    key: 'renderLineItemPrice',
    value: function renderLineItemPrice() {
      return _react2.default.createElement(_Price2.default, {
        amount: Money.format(this.props.preTaxAmount, this.props.currency, this.props.config.store),
        extraClass: 'a-bold-price'
      });
    }
  }, {
    key: 'renderLineItemPricePerItem',
    value: function renderLineItemPricePerItem() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__pricePerItemLabel' },
          t('spree.item_price')
        ),
        _react2.default.createElement(_Price2.default, {
          amount: Money.format(this.props.preTaxAmount / this.props.quantity, this.props.currency, this.props.config.store)
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _context;

      var lng = this.props.params.lng;

      return _react2.default.createElement(
        'div',
        { styleName: 'lineItem', className: 'clearfix' },
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__details' },
          _react2.default.createElement(
            'div',
            { styleName: 'lineItem__detail' },
            _react2.default.createElement(
              'div',
              { styleName: 'lineItem__color' },
              _react2.default.createElement(_ColorSwatch2.default, {
                imageUrl: this.props.coveredUrl,
                substrate: this.props.substrate,
                hexRef: (0, _lineItem.hexRef)(this.variant()),
                name: ' ',
                available: (0, _lineItem.hasHexRef)(this.variant())
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lineItem__names' },
              _react2.default.createElement(
                'span',
                { styleName: 'lineItem__name' },
                this.props.variant.name
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                { styleName: 'lineItem__colorLabel' },
                (0, _lineItem.colorOption)(this.variant()).presentation
              ),
              _react2.default.createElement('div', { className: 'clearfix' }),
              _react2.default.createElement(
                'div',
                { styleName: 'lineItem__price--mobile' },
                this.renderLineItemPrice()
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lineItem__pricePerItem--mobile' },
                this.renderLineItemPricePerItem()
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            styleName: 'lineItem__size' + (this.userRoles().includes('customer_service') && this.variant().slug === 'colour-chip' ? '-chip' : '')
          },
          _react2.default.createElement(
            'div',
            { styleName: 'lineItem__options' },
            (0, _lineItem.sizeOption)(this.variant()).presentation,
            this.userRoles().includes('customer_service') && this.variant().slug === 'colour-chip' ? this.renderColourChipSizeSwitcher((0, _lineItem.sizeOption)(this.variant()).presentation) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__quantity' },
          _react2.default.createElement(_LineItemQuantitySelect2.default, {
            index: this.props.index,
            showInput: this.props.inputType === 'input',
            quantity: this.props.quantity,
            id: this.props.id,
            onChange: (_context = this.props).onChangeQuantity.bind(_context)
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__pricePerItem' },
          this.renderLineItemPricePerItem()
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__price' },
          this.renderLineItemPrice()
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'lineItem__removeLink' },
          _react2.default.createElement(_reactRouter.Link, {
            to: (0, _localisedPaths.localisedAction)(this.props.config.store, 'cart/remove/' + this.props.id, lng),
            'data-lineitem': this.props.id,
            className: 'a-link',
            styleName: 'lineItem__remove',
            onClick: (_context = this.props).onClickRemove.bind(_context)
          })
        ),
        _react2.default.createElement('input', {
          type: 'hidden',
          value: this.props.id,
          name: 'order[line_items_attributes][' + this.props.index + '][id]'
        })
      );
    }
  }]);
  return PaintersLineItem;
}(_react2.default.Component), _class2.propTypes = {
  id: _react.PropTypes.number.isRequired,
  quantity: _react.PropTypes.number.isRequired,
  preTaxAmount: _react.PropTypes.string,
  currency: _react.PropTypes.string
}, _class2.defaultProps = {
  variant: {},
  onChangeQuantity: function onChangeQuantity() {},
  onClickRemove: function onClickRemove() {},
  switchChipSize: function switchChipSize() {}
}, _class2.contextTypes = {
  config: _react.PropTypes.any
}, _temp)) || _class) || _class) || _class);
exports.default = PaintersLineItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/LineItem/painters.js
// module id = 2290
// module chunks = 0